import { NgModule } from '@angular/core';
import { IconButtonModule } from '../../directives/icon-button/icon-button.module';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { PositionMediaFormComponent } from './position-media-form.component';
import { TextEditorModule } from '../../components';
import { RnplCommonModule } from 'common/src/modules';
import { SafePipeModule } from 'safe-pipe';
import { OnlyDigitsModule } from '../../directives/only-digits/only-digits.module';

@NgModule({
  declarations: [
    PositionMediaFormComponent
  ],
  imports: [
    IconButtonModule,
    CommonModule,
    ReactiveFormsModule,
    RnplCommonModule,
    TranslateModule,
    TextEditorModule,
    SafePipeModule,
    OnlyDigitsModule
  ],
  exports: [PositionMediaFormComponent],
  entryComponents: [PositionMediaFormComponent],
})
export class PositionMediaFormModule { }
